import { useTheme } from "@mui/material";
import React from "react";
import DSBox from "./themes-views/system-design/DSBox";
import useAppContext from "./hooks/useAppContext";
import DSSnackbar from "./themes-views/system-design/DSSnackbar";
import DSAlert from "./themes-views/system-design/DSAlert";
import { Outlet } from "react-router";

const MainLayout = () => {
  const { palette } = useTheme();
  const { alert, showAlert } = useAppContext();

  return (
    <DSBox
      sx={{
        backgroundColor: palette.background.default,
      }}
    >
      <DSBox
        sx={{
          flexGrow: 1,
          paddingX: { lg: "1.1%" },
          backgroundColor: palette.background.default,
        }}
      >
        <Outlet />
      </DSBox>
      {alert && (
        <DSSnackbar
          open={!!alert}
          autoHideDuration={5000}
          onClose={() => showAlert(undefined)}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <DSAlert message={alert?.message} alertType={alert?.alertType} />
        </DSSnackbar>
      )}
    </DSBox>
  );
};

export default MainLayout;
